import { makeBaseSvgIconProps } from './_utils/makeBaseSvgIconProps'

export const IconStation = () => {
  return (
    <svg {...makeBaseSvgIconProps('0 0 36 36')}>
      <path fill="currentColor" d="M18 0 36 18 18 36 0 18z" />
    </svg>
  )
}
